import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Combo2 } from '../../../models/combo';
import { SpinnerService } from '../../../services/spinner.service';
import { SnackbarService } from '../../../services/snackbar.service';
import {
  DocumControllerService,
  TipoDocumentoControllerService,
  TipoDocumentoModel,
} from 'api-rest';
import { DocumentService } from '../../../services/document.service';

@Component({
  selector: 'app-waste-managers-detail-document-dialog',
  templateUrl: './waste-managers-detail-document-dialog.component.html',
  styleUrls: ['./waste-managers-detail-document-dialog.component.scss'],
})
export class WasteManagersDetailDocumentDialogComponent implements OnInit {
  formGroup!: FormGroup;
  gestorInfo!: any;
  tiposDocumento!: Array<TipoDocumentoModel>;
  adjuntosBlob: Array<File> = [];
  botonEstado: boolean = false;
  flagTooltip: boolean = false;

  containerPoseedores: string = this.environment.documentContainerHolders;

  constructor(
    @Inject('environment') private environment: any,
    public dialogRef: MatDialogRef<WasteManagersDetailDocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private tipoDocumentoControllerService: TipoDocumentoControllerService,
    private documControllerSrv: DocumControllerService,
    public spinnerSrv: SpinnerService,
    private documentService: DocumentService,
    private snackbarSrv: SnackbarService
  ) {
    this.gestorInfo = this.data.gestorInfo;

    this.formGroup = this.formBuilder.group({
      tipoDocumento: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      descripcion: [{ value: null, disabled: false }, Validators.maxLength(255)],
    });
  }

  ngOnInit(): void {
    this.cargarDocumentos();
    this.cargarTooltip();
  }

  cargarTooltip() {
    this.formGroup
      .get('tipoDocumento')
      ?.valueChanges.subscribe((value: any) => {
        //if (value == 4) {
        //  this.flagTooltip = true;
        //} else {
          this.flagTooltip = false;
        //}
      });
  }

  cargarDocumentos(): void {
    this.tipoDocumentoControllerService.listarTipoDocumentos().subscribe({
      next: (response: any) => {
        // Filtrar solo los documentos con ids 1, 4, 5 y 13 (contrato, otros, adenda, autorizacion)
        this.tiposDocumento = response.filter((doc: TipoDocumentoModel) => [1, 4, 5, 13].includes(Number(doc.id)));
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  cerrar(): void {
    this.dialogRef.close(null);
  }

  guardar(): void {
    this.formGroup.markAllAsTouched();
    this.formGroup.updateValueAndValidity();
    if (this.formGroup.valid) {
      if (this.adjuntosBlob?.length > 0) {
        let id = this.gestorInfo.id! ?? null;
        let typeDoc = this.formGroup.controls['tipoDocumento'].value! ?? null;
        let docDesc = this.formGroup.controls['descripcion'].value! ?? '';
        this.setBotonEstado(true);
        this.spinnerSrv.loadingShow();
        this.documControllerSrv
          .uploadDoc(
            this.containerPoseedores,
            typeDoc,
            id,
            'GESTOR_POSEEDOR',
            this.adjuntosBlob[0]?.name,
            this.adjuntosBlob[0],
            docDesc
          )
          .subscribe({
            next: () => {
              this.spinnerSrv.loadingHide();
              this.snackbarSrv.showSnackBar(
                'Documento subido satisfactoriamente',
                'success'
              );
              this.dialogRef.close(true);
            },
            error: (err) => {
              this.setBotonEstado(false);
              console.log(err);
              this.spinnerSrv.loadingHide();
              this.snackbarSrv.showSnackBar(
                'Error al subir documento',
                'error'
              );
            },
            complete: () => {
              this.spinnerSrv.loadingHide();
            },
          });
      }
    }
  }
  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }

  attachAdjunto(archivo: File | null): void {
    if (archivo != null) {
      if (archivo.size === 0) {
        this.snackbarSrv.showSnackBar(
          'No se puede subir un fichero vacío',
          'error'
        );
      } else if (archivo.size > 12 * 1024 * 1024) { // 5 MB
        this.snackbarSrv.showSnackBar(
          'El fichero supera el tamaño máximo permitido de 12 MB',
          'error'
        );
      } else {
        this.adjuntosBlob.push(archivo);
      }
    }
  }

  setBotonEstado(estado: boolean) {
    return (this.botonEstado = estado);
  }
}
